// @core/api/endpoints/authn/send_one_time_code.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SendOneTimeCodeRequest,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Send one-time login code
 * Sends a one-time login code to the user's email address. The code can be used for passwordless authentication and expires after a short time period.
 * @public This endpoint does not require authentication
 */
export async function SendOneTimeCode(
  data: SendOneTimeCodeRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/auth/signin/code/send`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<Response>(requestPath, data, requestOptions);
}
